import { Component, Input, OnInit } from "@angular/core";
import { MatRadioChange } from "@angular/material/radio";
import { AssistantContentMessage, AssistantActionButton } from "../../../models";
import { AssistantService } from "../../../services/assistant.service";

@Component({
    selector: "app-assistant-banner-content-message",
    templateUrl: "./assistant-banner-content-message.component.html",
    styleUrls: ["./assistant-banner-content-message.component.scss"],
    standalone: false
})
export class AssistantBannerContentMessageComponent implements OnInit {
  @Input() message: AssistantContentMessage;

  constructor(private assisantService: AssistantService) {}

  ngOnInit(): void {}

  onRadioChange(e: MatRadioChange): void {
    const radio = this.message.radioButtons.find(i => i.value === e.value);

    this.assisantService.raiseRadioButton(this.message, radio);
  }

  onActionBtnClick(btn: AssistantActionButton): void {
    this.assisantService.raiseActionButton(btn);
  }
}
